import { api } from "./axiosConfig";

export const verificationService = {
  async sendEmail(): Promise<void> {
    await api.post("/api/v1/auth/verify-email/send");
  },

  async confirmEmail(token: string): Promise<void> {
    await api.post("/api/v1/auth/verify-email/confirm", { token });
  },

  async sendPhone(): Promise<void> {
    await api.post("/api/v1/auth/verify-phone/send");
  },

  async confirmPhone(code: string): Promise<void> {
    await api.post("/api/v1/auth/verify-phone/confirm", { code });
  },
};
